import React from "react";

import { IgSwitch, IgTypography } from "@intelligems/ig-theme";
import { Box, Grid } from "@mui/material";
import { useProgressBarContext } from "@src/features/personalizations/components/offerModifications/userInterfaces/progressBar/ProgressBarContext";

export const CartValueToggle = () => {
  const { aboveThreshold, setAboveThreshold } = useProgressBarContext();

  return (
    <Grid item container alignItems={"center"} spacing={2}>
      <Grid item>
        <IgTypography>Above threshold</IgTypography>
      </Grid>

      <Grid item>
        <IgSwitch
          checked={aboveThreshold}
          onClick={() => setAboveThreshold(!aboveThreshold)}
        />
      </Grid>
    </Grid>
  );
};
